import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/api/login');
  };

  const handleSignup = () => {
    navigate('/api/signup');
  };

  return (
    <div className="landing-page">
      <div className="landing-page-container">
        <h1 className="app-title">Bounty</h1>
        <p className="tagline">Discover opportunities. Post gigs. Connect seamlessly.</p>
        <div className="button-group">
          <button className="btn login-btn" onClick={handleLogin}>
            Login
          </button>
          <button className="btn signup-btn" onClick={handleSignup}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;